// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2cU-W","inner":"Footer_inner__3LAdw"};